import React, { useMemo, useRef, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Button, Form, Input, Label } from "reactstrap"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import moment from "moment"
import { getProviderStock } from "store/provider-dashboard/provider-dashboard-action"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"

const ProviderStockFilter = ({
  onSubmit,
  onCategoryChange,
  provStockLoading,
  getSearchData,
  onProviderSearchHandler,
}) => {
  // Retrieve provider IPs data from Redux store
  const providerIps = useSelector(state => state.providerDashboard.ProviderIps)
  // Retrieve projects IPs data from Redux store
  const projects = useSelector(
    state => state.providerDashboard.providerProjects
  )
  // Retrieve provider items data from Redux store
  const ProviderItems = useSelector(
    state => state.providerDashboard.ProviderItems
  )

  // Retrieve provider item categories data from Redux store
  const ProviderItemCategoires = useSelector(
    state => state.providerDashboard.ProviderItemCategoires
  )

  // get filtered items based select box props needs
  const filteredItems = useMemo(
    () =>
      ProviderItems?.data.map(item => ({
        value: item.id,
        label: `${item.unfp_item_name} ( ${item.item_name} )`,
      })),
    [ProviderItems]
  )

  const dispatch = useDispatch()

  const fromdateFlatpicker = useRef(null)
  const todateFlatpicker = useRef(null)
  const [Ips, setIps] = useState(null)
  const [Categories, setCategories] = useState(null)
  const [item, setItem] = useState(null)
  const [batchNumber, setBatchNumber] = useState("")
  const [fromDate, setFromDate] = useState(null)
  const [toDate, setToDate] = useState(null)
  const [project, setProject] = useState(null)

  // Store filtered data and dispatch the action using onProviderSearchHandler callback function
  const handleSubmit = () => {
    let searchs = {}
    searchs.ips = Ips ? Ips.value : null
    searchs.project = project ? project.value : null
    searchs.category = Categories ? Categories.value : null
    if (item) {
      searchs.item = item.map(ite => (ite.value ? ite.value : ite))
    }

    searchs.batchNumber = batchNumber
    searchs.from = fromDate
    searchs.to = toDate
    onSubmit(searchs)
    onProviderSearchHandler(searchs)
    getSearchData({ Ips, Categories, item, batchNumber, fromDate, toDate })
  }

  // const IpsChangeHandler = ip => {
  //   setIps(ip)
  // }

  // store Item Categories and fetch items based item category
  const onCategoryChangeHandler = category => {
    onCategoryChange(category.value)
    setCategories(category)
  }

  // store multiple items based selected
  const onItemChangeHandler = item => {
    const check = item.some(ite => ite.value === "all")
    if (check) {
      setItem(filteredItems)
    } else {
      setItem(item)
    }
  }

  // store project value
  const onProjectChangeHandler = proj => {
    setProject(proj)
  }

  // clear search when clear button clicked
  const onClearHandler = () => {
    fromdateFlatpicker.current.flatpickr.clear()
    todateFlatpicker.current.flatpickr.clear()
    setIps(null)
    setCategories(null)
    setItem(null)
    setProject(null)
    setBatchNumber("")
    setFromDate(null)
    setToDate(null)
    getSearchData({})
    dispatch(providerDashboardAction.resetProviderItems())
    dispatch(getProviderStock())
  }

  return (
    <Form
      onSubmit={e => {
        e.preventDefault()
        handleSubmit()
        return false
      }}
    >
      <div className="mb-3">
        <Label className="form-label">Projects</Label>
        {projects?.data && (
          <Select
            options={[{ value: "all", label: "All" }, ...projects?.data]}
            value={project}
            onChange={onProjectChangeHandler}
          />
        )}
      </div>

      <div className="mb-3">
        <Label className="form-label">Item Categories</Label>
        {ProviderItemCategoires?.data && (
          <Select
            placeholder="All Categories"
            options={[{ value: "all", label: "All" }, ...ProviderItemCategoires?.data]}
            value={Categories}
            onChange={onCategoryChangeHandler}
          />
        )}
      </div>

      {filteredItems && (
        <div className="mb-3">
          <Label className="form-label">Items</Label>
          <Select
            isMulti={true}
            options={[{ value: "all", label: "All" }, ...filteredItems]}
            value={item}
            onChange={onItemChangeHandler}
          />
        </div>
      )}
      <div className="mb-3">
        <Label className="form-label">Batch Number</Label>
        <Input
          name="name"
          value={batchNumber}
          onChange={value => {
            setBatchNumber(value.target.value)
          }}
          placeholder="Name"
          type="text"
        />
      </div>

      <div className="mb-3 ">
        <Label className="form-label">From Date</Label>
        <Flatpickr
          ref={fromdateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setFromDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
        <br />
        <Label className="form-label">To Date</Label>
        <Flatpickr
          ref={todateFlatpicker}
          className="form-control d-block"
          placeholder="dd M,yyyy"
          options={{
            altInput: true,
            altFormat: "Y-m-d",
            dateFormat: "Y-m-d",
          }}
          onChange={value => {
            setToDate(moment(value[0]).format("YYYY-MM-DD"))
          }}
        />
      </div>

      <div className="d-flex flex-wrap gap-2">
        <Button
          type="submit"
          className="btn btn-sm btn-primary"
          color="primary"
          disabled={provStockLoading}
        >
          {provStockLoading ? "Please Wait..." : "Search"}
        </Button>
        <Button
          onClick={onClearHandler}
          className="btn btn-sm btn-danger"
          color="primary"
        >
          Clear
        </Button>
      </div>
    </Form>
  )
}

export default ProviderStockFilter
